import Pagination from "./Pagination";

const DataTable = ({
  data,
  columns,
  totalItems,
  itemsPerPage,
  currentPage,
  paginate,
  noDataMessage = "No data found",
  showPagination = true,
  minWidth = "1000px",
  renderExtraHeader = null,
  onRowClick = null,
  rowClassName = null,
}) => {
  return (
    <>
      <div className="finance-table-outer">
        <div className="table-responsive finance-table-inner">
          <table className="table finance-table mb-0" style={{ minWidth }}>
            <thead>
              <tr>
                {columns.map((column, index) => (
                  <th
                    key={index}
                    className={`finance-th ${column.className || ""} ${column.headerClassName || ""}`}
                    style={column.style || {}}
                  >
                    <span className="finance-th-label">{column.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {renderExtraHeader && renderExtraHeader()}
              {data.length > 0 ? (
                data.map((item, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className={`finance-tr ${rowClassName ? rowClassName(item) : ""}`}
                    onClick={() => onRowClick && onRowClick(item)}
                    style={{ cursor: onRowClick ? "pointer" : "default" }}
                  >
                    {columns.map((column, colIndex) => (
                      <td
                        key={colIndex}
                        className={`finance-td ${column.className || ""} ${column.cellClassName || ""}`}
                        style={{
                          ...(column.style || {}),
                          ...(column.cellStyle ? column.cellStyle(item) : {}),
                        }}
                      >
                        {column.render
                          ? column.render(item, rowIndex)
                          : item[column.key]}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="finance-empty-row">
                    <div className="d-flex flex-column align-items-center py-5">
                      <i className="far fa-folder-open fs-30 text-muted mb-2"></i>
                      <span className="text-muted fs-13">{noDataMessage}</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showPagination && totalItems > 0 && (
        <Pagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          paginate={paginate}
        />
      )}

      <style>{`
        .finance-table-outer {
          border-radius: 10px;
          border: 1px solid #eaecf0;
          background: #fff;
          overflow: hidden;
        }

        .finance-table-inner {
          overflow-x: auto;
          overflow-y: visible;
          -webkit-overflow-scrolling: touch;
        }

        .finance-table {
          border-collapse: collapse;
          width: 100%;
        }

        /* Header */
        .finance-table thead tr {
          background: #f8fafc;
          border-bottom: 1.5px solid #eaecf0;
          white-space: nowrap;
        }

        .finance-table thead th {
          padding: 14px 16px;
          border: none;
          vertical-align: middle;
          text-align: inherit;
        }

        .finance-th-label {
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          color: #667085;
        }

        /* Body rows */
        .finance-table tbody {
          white-space: nowrap;
        }

        .finance-tr {
          border-bottom: 1px solid #f2f4f7;
          transition: background 0.15s ease;
        }

        .finance-tr:last-child {
          border-bottom: none;
        }

        .finance-tr:hover {
          background: #f8fafc;
        }

        .finance-td {
          padding: 14px 16px;
          font-size: 13px;
          color: #344054;
          vertical-align: middle;
          border: none;
          text-align: inherit;
        }

        /* Empty state */
        .finance-empty-row {
          border: none;
          color: #98a2b3;
          font-size: 13px;
          text-align: center;
        }
        .last-child-border-0:last-child {
          border-right: none !important;
        }
      `}</style>
    </>
  );
};

export default DataTable;
